<template lang="pug">
  .container
    el-row.flexend
      el-pagination(:current-page.sync="page", layout="prev, pager, next", :total="totalPage", @current-change="changePage")
    el-row.table-row
      el-col(:span="5").mar-right-16.header-table-background
        .header-table-block
          el-button(type="primary", @click="clickCreateButton") เพิ่มแผนการดูแล
          el-dialog.careplan(:visible.sync="dialogAddVisible")
            el-form(:model="form")
              el-form-item(label="หัวข้อการดูแล", prop="title")
                el-input(type="text", v-model="form.title").input-dialog
              el-form-item(label="ตัวอย่างรายงาน", prop="description")
                el-input(type="textarea", :rows="3", v-model="form.description").input-dialog
            span(slot="footer", class="dialog-footer")
              el-button(@click="dialogAddVisible = false").button-border-blue ยกเลิก
              el-button(type="primary", @click="createCarePlan", v-if="status === 'create'") สร้าง
              el-button(type="primary", @click="updateCarePlan(plans[editIndex])", v-if="status === 'edit'") อัพเดท
      el-col(:span="5", v-for="(sheet, index) in sheets", :key="'plane1 ' +index").mar-right-16
        .item-block.no-pad-topbottom.border.border-top
          .header {{ dateTitle(sheet)[0] }}
            img(v-if="dateTitle(sheet)[1]", :src="dateTitle(sheet)[1]", width="20px", height="20px", style="margin-left: 15px; vertical-align: middle;")
        .item-block.no-pad-topbottom.no-border-top.border.type-box
          .subheader {{ sheet.caregiver }}
          .rightbox(style="display: flex; flex-direction: column; align-items: flex-end")
            .reported-status.green-bg(v-if="sheet.submitStatus === '<24'") < 24 ชม.
            .reported-status.gray-bg(v-if="sheet.submitStatus === '<48'") < 48 ชม.
            .reported-status.red-bg(v-if="sheet.submitStatus === '>48'") > 48 ชม.
            .reported-date {{ createdAtToString(sheet) }}
    el-row
      el-col(:span="5").mar-right-16.header-table-background
        .header-table-block
          .progress-header อาการโดยรวม
          .progress-item(v-for="item in symptoms", :key="item") {{ item }}
      el-col(:span="5", v-for="(sheet, index) in sheets", :key="'plane2 ' +index").mar-right-16.no-border-top.border
        .item-block
          .progress-header อาการโดยรวม
          .progress-item(v-for="(item, itemIndex) in generalSplit(sheet)", :key="item + index + itemIndex") {{ item }}
    el-dialog.careplan(:visible.sync="dialogEditVisible", width="50%")
      .edit-container
        span คุณต้องการที่จะทําอะไรกับหัวข้อการดูแลนี้ ?
        .row
          el-button(type="primary", @click="editCarePlan(plans[editIndex])", icon="el-icon-edit").button-border-blue  แก้ไข
          el-button(type="primary", @click="enableCarePlan(plans[editIndex])", icon="el-icon-view", v-if="!isEnabled").button-border-blue  เปิดการใช้งาน
          el-button(type="primary", @click="disableCarePlan(plans[editIndex])", v-else).button-border-blue
            span(style="display: flex; flex-direction: row;")
              img(src="@/assets/icon/invisible.svg", width="18px", height="18px").mar-right-8
              div ปิดการใช้งาน
          el-button(type="primary", @click="deleteCarePlan(plans[editIndex])", icon="el-icon-delete").button-border-blue  ลบ
    el-row(v-for="(plan, index) in plans" , :key="'plan ' + index")
      el-row.table-row
        el-col(:span="5").mar-right-16.header-table-background
          .header-table-block.no-border-bottom.margin-bottom-6
            .button-edit(@click="clickEditButton(index, plan)", v-if="plan.editable")
              .i.el-icon-edit
              .margin-left-4 แก้ไข
            .button-hind(v-else)
            .progress-header(v-if="plan.enabled") {{ plan.title }}
            .progress-header(v-else).gray-text {{ plan.title }}
            .progress-item(v-if="plan.enabled") {{ plan.description }}
            .progress-item(v-else).gray-text {{ plan.description }}
        el-col(:span="5", v-for="(sheet, indexPlane) in sheets", :key="'plane3 ' +indexPlane").mar-right-16.no-border-top.border.no-border-bottom
          .header-table-block.no-border-bottom.margin-bottom-6(v-if="sheet.records[index+3] && index !== plans.length")
            .button-hind
            .progress-header(v-if="plan.enabled") {{ sheet.records[index+3].title }}
            .progress-header(v-else).gray-text {{ sheet.records[index+3].title }}
            .progress-item(v-if="plan.enabled && sheet.records[index+3].title !== ''") {{ sheet.records[index+3].description }}
            .progress-item(v-if="!plan.enabled && sheet.records[index+3].title !== ''").gray-text {{ sheet.records[index+3].description }}
          .header-table-block.no-border-bottom.margin-bottom-6(v-if="!sheet.records[index+3] && index !== plans.length")
            .button-hind
            .progress-header
            .progress-item
      el-row.table-row
        el-col(:span="5").mar-right-16.header-table-background
          .header-table-block
            .progress-picture(v-if="plan.enabled") รูปภาพ
            .progress-picture(v-else).gray-text รูปภาพ
        el-col(v-if="sheet.records[index+3]", :span="5", v-for="(sheet, indexPlane) in sheets", :key="'plane4 ' +indexPlane").mar-right-16.no-border-top.border
          div(v-if="sheet.records[index+3]", v-for="photo in sheet.records[index+3].photos")
            .item-block(v-if="sheet.records[index+3] && photo.substring(0,8) === 'https://'")
              a(:href="photo", target="_blank")
                img(:src="photo").picture
          .item-block(v-if="!sheet.records[index+3] || sheet.records[index+3].photos.length === 0")
            .block-no-image
              .i.el-icon-picture
        el-col(v-else, :span="5").mar-right-16.no-border-top.border
          .item-block
    el-row
      el-row.table-row
        el-col(:span="5").mar-right-16.header-table-background
          .header-table-block.no-border-bottom.margin-bottom-6
            .button-hind
            .progress-header เรื่องอื่น ๆ
            .progress-item
        el-col(:span="5", v-for="(sheet, indexPlane) in sheets", :key="'plane3 ' +indexPlane").mar-right-16.no-border-top.border.no-border-bottom
          .header-table-block.no-border-bottom.margin-bottom-6(v-if="sheet.records[1]")
            .button-hind
            .progress-header เรื่องอื่น ๆ
            .progress-item {{ sheet.records[1].description }}
      el-row.table-row
        el-col(:span="5").mar-right-16.header-table-background
          .header-table-block
            .progress-picture รูปภาพ
        el-col(v-if="sheet.records[1]", :span="5", v-for="(sheet, indexPlane) in sheets", :key="'plane4 ' +indexPlane").mar-right-16.no-border-top.border
          div(v-if="sheet.records[1]", v-for="photo in sheet.records[1].photos")
            .item-block(v-if="sheet.records[1].photos.length > 0 && photo.substring(0,8) === 'https://'")
              a(:href="photo", target="_blank")
                img(:src="photo").picture
          .item-block(v-if="!sheet.records[1] || sheet.records[1].photos.length === 0")
            .block-no-image
              .i.el-icon-picture
        el-col(v-else, :span="5").mar-right-16.no-border-top.border
          .item-block
    el-row
      el-row.table-row
        el-col(:span="5").mar-right-16.header-table-background
          .header-table-block.no-border-bottom.margin-bottom-6
            .button-hind
            .progress-header เรื่องที่จะปรึกษา
            .progress-item
        el-col(:span="5", v-for="(sheet, indexPlane) in sheets", :key="'plane3 ' +indexPlane").mar-right-16.no-border-top.border.no-border-bottom
          .header-table-block.no-border-bottom.margin-bottom-6(v-if="sheet.records[2]")
            .button-hind
            .progress-header เรื่องที่จะปรึกษา
            .progress-item {{ sheet.records[2].description }}
      el-row.table-row
        el-col(:span="5").mar-right-16.header-table-background
          .header-table-block
            .progress-picture รูปภาพ
        el-col(v-if="sheet.records[2]", :span="5", v-for="(sheet, indexPlane) in sheets", :key="'plane4 ' +indexPlane").mar-right-16.no-border-top.border
          div(v-if="sheet.records[2]", v-for="photo in sheet.records[2].photos")
            .item-block(v-if="sheet.records[2].photos.length > 0 && photo.substring(0,8) === 'https://'")
              a(:href="photo", target="_blank")
                img(:src="photo").picture
          .item-block(v-if="!sheet.records[2] || sheet.records[2].photos.length === 0")
            .block-no-image
              .i.el-icon-picture
        el-col(v-else, :span="5").mar-right-16.no-border-top.border
          .item-block
</template>

<style lang="scss" scoped>
  .header {
    font-family: 'Sukhumvit-Bold';
    font-size: 24px;
    font-weight: bold;
    color: #606266;
  }

  .subheader {
    font-family: 'Sukhumvit-Bold';
    font-size: 20px;
    font-weight: bold;
    color: #606266;
  }
</style>

<style lang="scss">
  .container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 102px;
  }

  .flexend {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .el-pagination {
    margin-top: 32px;
    margin-bottom: 16px;
  }

  .el-pager li, .el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon {
    font-family: 'Sukhumvit-Bold';
    font-size: 16px;
  }

  .table-row {
    display: flex;
    align-items: stretch;
  }

  .mar-right-16 {
    margin-right: 16px;
  }

  .mar-right-8 {
    margin-right: 8px;
  }

  .header-table-background {
    background-color: #f5f7fa;
  }

  .header-table-block {
    padding: 18px 16px 16px 16px;
    border-bottom: 1.5px solid #dcdfe6;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .el-button {
    font-family: 'Sukhumvit-SemiBold';
    font-size: 18px;
    font-weight: 600;
  }

  .el-dialog.careplan {
    border-radius: 8px;
    padding: 0 48px 16px 57px;
  }

  .el-form-item__label {
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: right;
    color: #303133;
  }

  .item-block {
    padding: 18px 12px 16px 12px;
  }

  .no-pad-topbottom {
    padding-top: 0px;
    padding-bottom: 0px;
    display: flex;
    align-items: center;
    height: 41.8px;
  }

  .border {
    border: 1.5px solid #dcdfe6;
  }

  .no-border-top {
    border-top: none;
  }

  .border-top {
    border-top: 1.5px solid #dcdfe6;
  }

  .no-border-bottom {
    border-bottom: none;
  }

  .no-border-top {
    border-top: none;
  }

  .margin-bottom-6 {
    margin-bottom: 6px;
  }

  .type-box {
    display: flex;
    justify-content: space-between;
  }

  .reported-status {
    color: white;
    font-size: 10px;
    border-radius: 8px;
    padding: 0px 6px;
  }

  .green-bg {
    background-color: #67c23a;
  }

  .gray-bg {
    background-color: #909399;
  }

  .red-bg {
    background-color: #f56c6c;
  }

  .reported-date {
    color: #c0c4cc;
    font-size: 11px;
    margin-top: 3px;
    line-height: 1;

  }

  .progress-header {
    font-family: 'Sukhumvit-Bold';
    font-size: 20px;
    font-weight: 900;
    color: #606266;
    margin-bottom: 4px;
  }

  .progress-item {
    font-family: 'Sukhumvit';
    font-size: 16px;
    font-weight: 500;
    color: #606266;
    word-wrap: break-word;
    margin-bottom: 3px;
  }

  .button-edit, .button-hind {
    font-family: 'Sukhumvit-SemiBold';
    font-size: 16px;
    color: #c0c4cc;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50px;
    height: 24px;
    justify-content: flex-end;
    align-self: flex-end;
    margin-bottom: -2px;
  }

  .button-edit:hover {
    color: #606266;
    cursor: pointer;
  }

  .margin-left-4 {
    margin-left: 4px;
  }

  .button-border-blue {
    border: 2px solid #409eff;
    color: #409eff;
    font-weight: 900;
    font-size: 18px;
    background-color: white;
  }

  .gray-text {
    font-family: 'Sukhumvit';
    color: #c0c4cc;
  }

  .progress-picture {
    font-family: 'Sukhumvit';
    font-size: 16px;
    font-weight: 500;
  }

  .picture {
    width: 100%;
  }

  .block-no-image {
    width: 100%;
    height: 114px;
    border: dashed 1.5px #dcdfe6;
    color: #c0c4cc;
    font-size: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .input-dialog {
    font-family: 'Sukhumvit-SemiBold';
    font-size: 18px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #606266;
  }

  .edit-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    font-family: 'Sukhumvit';
    font-size: 18px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #606266;
  }

  .row {
    display: flex;
    flex-direction: row;
    margin-top: 32px;
  }

</style>

<script>
import moment from 'moment'
import CareplanModel from '@/model/CareplanModel'
import SheetsCareplanModel from '@/model/SheetsCareplanModel'
export default {
  name: 'PatientCareProgress',
  props: {
    patientId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.getCarePlan()
  },
  data () {
    return {
      page: 1,
      totalPage: 0,
      dialogAddVisible: false,
      dialogEditVisible: false,
      editIndex: '',
      isEnabled: '',
      status: '',
      form: {
        title: '',
        description: '',
      },
      symptoms: ['สีหน้าคนไข้', 'อุณหภูมิ', 'การเต้นของหัวใจ', 'ความดันตอนเข้าเวร', 'ความดันตอนออกเวร'],
      plans: [],
      sheets: [],
    }
  },
  methods: {
    async getCarePlan () {
      try {
        const raw = await this.$api.Careplan.list(this.patientId, this.page)
        if (raw !== '') {
          this.totalPage = raw.paginate.maxPage * 10
          this.plans = []
          this.sheets = []
          for (let i = 0; i < raw.plans.length; i++) {
            if (raw.plans[i].type === 'custom') {
              this.plans.push(CareplanModel.fromJSON(raw.plans[i]))
            }
          }
          for (let i = 0; i < raw.sheets.length; i++) {
            this.sheets.push(SheetsCareplanModel.fromJSON(raw.sheets[i]))
          }
        }
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    changePage (e) {
      this.getCarePlan()
    },
    clickCreateButton () {
      this.form.title = ''
      this.form.description = ''
      this.dialogAddVisible = true
      this.status = 'create'
    },
    clickEditButton (index, progress) {
      this.editIndex = index
      this.dialogEditVisible = true
      this.status = 'edit'
      this.isEnabled = progress.enabled
    },
    async createCarePlan () {
      const careplan = {
        patientId: this.patientId,
        type: 'custom',
        title: this.form.title.toString(),
        description: this.form.description,
      }
      try {
        await this.$api.Careplan.create(careplan)
        this.dialogAddVisible = false
        this.getCarePlan()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    editCarePlan (progress) {
      this.form.title = progress.title
      this.form.description = progress.description
      this.dialogAddVisible = true
      this.dialogEditVisible = false
    },
    async updateCarePlan (careplan) {
      const careplanDetail = {
        id: careplan.id,
        title: this.form.title,
        description: this.form.description,
      }
      try {
        await this.$api.Careplan.update(careplanDetail)
        this.dialogAddVisible = false
        this.getCarePlan()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async enableCarePlan (careplan) {
      try {
        this.dialogEditVisible = false
        await this.$confirm('คุณต้องการเปิดการใช้งานหัวข้อการดูแลนี้', '', {
          confirmButtonText: ' เปิดการใช้งาน ',
          cancelButtonText: 'ยกเลิก',
          cancelButtonClass: 'button-border-blue',
          type: 'warning',
        })
        try {
          await this.$api.Careplan.enable(careplan.id)
          this.getCarePlan()
        } catch (error) {
          this.showErrorDialog(error)
        }
      } catch (error) {}
    },
    async disableCarePlan (careplan) {
      try {
        this.dialogEditVisible = false
        await this.$confirm('คุณต้องการปิดการใช้งานหัวข้อการดูแลนี้', '', {
          confirmButtonText: ' ปิดการใช้งาน ',
          cancelButtonText: 'ยกเลิก',
          cancelButtonClass: 'button-border-blue',
          type: 'warning',
        })
        try {
          await this.$api.Careplan.disable(careplan.id)
          this.getCarePlan()
        } catch (error) {
          this.showErrorDialog(error)
        }
      } catch (error) {}
    },
    async deleteCarePlan (careplan) {
      try {
        this.dialogEditVisible = false
        await this.$confirm('คุณต้องการลบหัวข้อการดูแลนี้', '', {
          confirmButtonText: ' ลบ ',
          cancelButtonText: 'ยกเลิก',
          cancelButtonClass: 'button-border-blue',
          type: 'warning',
        })
        try {
          await this.$api.Careplan.deleteCarePlan(careplan.id)
          this.getCarePlan()
        } catch (error) {
          this.showErrorDialog(error)
        }
      } catch (error) {}
    },
    generalSplit (sheet) {
      if (!sheet.records[0]) return ['-', '-', '-', '-', '-']
      else if (sheet.records[0].description.split('\n').length === 4) {
        let tmp = '-\n' + sheet.records[0].description
        return tmp.split('\n')
      } else return sheet.records[0].description.split('\n')
    },

    dateTitle (sheet) {
      let type, date, tmpDate
      tmpDate = sheet.date.split('-')
      date = tmpDate[2] + '/' + tmpDate[1] + '/' + tmpDate[0]
      if (sheet.shiftType === 'day') type = require('../../assets/icon/sun.svg')
      else if (sheet.shiftType === 'night') type = require('../../assets/icon/moon.svg')
      else type = ''
      return [date, type]
    },
    createdAtToString (sheet) {
      const date = moment(sheet.createdAt).format('DD/MM/YYYY HH:mm')
      return date
    },
  },
}

</script>
